import React, { createContext, useContext, useEffect } from 'react';

interface BackButtonContextType {
  isBackButtonShown: boolean;
  setIsBackButtonShown: React.Dispatch<React.SetStateAction<boolean>>;
}

const BackButtonContext = createContext<BackButtonContextType>({
  isBackButtonShown: true,
  setIsBackButtonShown: ((prevState: boolean) => undefined) as any,
});

export const useFormWithoutBackButton = () => {
  const { setIsBackButtonShown } = useContext(BackButtonContext);

  useEffect(() => {
    setIsBackButtonShown(false);

    return () => setIsBackButtonShown(true);
  }, [setIsBackButtonShown]);
};

export default BackButtonContext;
